/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React from "react";
import Icon from "../Icon";
import { string } from "prop-types";
import "./alertBox.scss";

class AlertBox extends React.Component {
  render() {
    return (
      <div
        dir={this.props.dir}
        className={"pe-proto alert-box " + this.props.styling}
        role="alert"
      >
        <div
          dir={this.props.dir}
          style={{ float: this.props.dir === "ltr" ? "right" : "left" }}
          className="close-title"
        >
          <button
            type="button"
            className="pe-icon--btn"
            aria-label="Close success dialog"
            title="Close success dialog"
          >
            <Icon fileName="remove-sm-24" title="Close" name="close" />
          </button>
        </div>
        {this.props.children}
      </div>
    );
  }
}

AlertBox.propTypes = {
  styling: string,
  locale: string,
  dir: string,
};

AlertBox.defaultProps = {
  styling: "",
  locale: "en",
  dir: "ltr",
};

export default AlertBox;
